/**
 * Vista "Cambiar correo" (menú Más) — autoservicio del promotor.
 *
 * Reusa los endpoints del cajero que YA están en producción
 * (cashier-correo-verificacion.js), con su doble prueba anti-takeover:
 *   1. El código va al correo NUEVO (probás que lo controlás).
 *   2. Confirmar exige la contraseña ACTUAL (una sesión robada no alcanza
 *      para secuestrar la cuenta cambiando su credencial de login).
 *
 * El correo actual sigue siendo válido hasta confirmar (re-verificación
 * con slot pendiente único — modelo del backend).
 */

import ApiClient from '../api-client.js';
import { t } from '../languages.js';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function renderCambiarCorreo() {
    const el = document.createElement('div');
    el.className = 'login-box';

    let paso = 'correo'; // 'correo' → 'confirmar'
    let correoNuevo = '';

    function render() {
        if (paso === 'correo') {
            const actual = (ApiClient.getUser() && ApiClient.getUser().email) || '';
            el.innerHTML = `
                <div style="text-align:center; margin-bottom:8px;">
                    <h1 style="margin:0 0 4px;">${t('cambiarCorreo.titulo')}</h1>
                    <p style="color:var(--text-dim); margin:0;">${actual ? `${t('cambiarCorreo.actual')}: <b>${actual}</b>` : t('cambiarCorreo.subtitulo')}</p>
                </div>
                <input type="email" id="cc-correo" placeholder="${t('cambiarCorreo.nuevo')}" autocomplete="email" inputmode="email" value="${correoNuevo}">
                <div class="error" id="cc-error"></div>
                <button class="btn btn-install" id="cc-enviar">${t('activacion.enviarCodigo')}</button>`;
            _bindCorreo();
        } else {
            el.innerHTML = `
                <div style="text-align:center; margin-bottom:8px;">
                    <h1 style="margin:0 0 4px;">${t('cambiarCorreo.titulo')}</h1>
                    <p style="color:var(--text-dim); margin:0;">${t('activacion.codigoEnviado')} <b>${correoNuevo}</b></p>
                </div>
                <input type="text" id="cc-codigo" placeholder="${t('activacion.codigo')}" inputmode="numeric" autocomplete="one-time-code" maxlength="6">
                <input type="password" id="cc-pass" placeholder="${t('cambiarCorreo.passwordActual')}" autocomplete="current-password">
                <div class="error" id="cc-error"></div>
                <div class="error" id="cc-ok" style="color:var(--accent-green, #2ecc71);"></div>
                <button class="btn btn-install" id="cc-confirmar">${t('cambiarCorreo.confirmar')}</button>
                <button class="btn" id="cc-reenviar" style="margin-top:8px; background:transparent; color:var(--text-dim);">${t('activacion.reenviar')}</button>`;
            _bindConfirmar();
        }
    }

    function _bindCorreo() {
        const correoEl = el.querySelector('#cc-correo');
        const errEl = el.querySelector('#cc-error');
        const btn = el.querySelector('#cc-enviar');

        let enProgreso = false;
        async function enviar() {
            if (enProgreso) return;
            const correo = (correoEl.value || '').trim().toLowerCase();
            if (!EMAIL_REGEX.test(correo)) {
                errEl.textContent = t('activacion.correoInvalido');
                return;
            }
            enProgreso = true;
            btn.disabled = true;
            btn.textContent = t('activacion.enviando');
            errEl.textContent = '';
            try {
                const r = await ApiClient.correoSolicitarCodigo(correo);
                if (!r.ok) {
                    errEl.textContent = r.mensaje || t('cambiarCorreo.error');
                    return;
                }
                correoNuevo = correo;
                paso = 'confirmar';
                render();
            } finally {
                enProgreso = false;
                if (btn.isConnected) {
                    btn.disabled = false;
                    btn.textContent = t('activacion.enviarCodigo');
                }
            }
        }
        btn.addEventListener('click', enviar);
        correoEl.addEventListener('keydown', e => {
            if (e.key === 'Enter') enviar();
        });
    }

    function _bindConfirmar() {
        const codigoEl = el.querySelector('#cc-codigo');
        const passEl = el.querySelector('#cc-pass');
        const errEl = el.querySelector('#cc-error');
        const okEl = el.querySelector('#cc-ok');
        const btn = el.querySelector('#cc-confirmar');
        const reenviarBtn = el.querySelector('#cc-reenviar');

        let enProgreso = false;
        async function confirmar() {
            if (enProgreso) return;
            const codigo = (codigoEl.value || '').trim();
            const password = passEl.value || '';
            errEl.textContent = '';
            okEl.textContent = '';

            if (!codigo) {
                errEl.textContent = t('activacion.codigoRequerido');
                return;
            }
            if (!password) {
                errEl.textContent = t('cambiarCorreo.faltaPassword');
                return;
            }

            enProgreso = true;
            btn.disabled = true;
            btn.textContent = t('cambiarCorreo.confirmando');
            try {
                const r = await ApiClient.correoVerificarCodigo({ codigo, password });
                if (!r.ok) {
                    errEl.textContent = r.mensaje || t('cambiarCorreo.error');
                    return;
                }
                okEl.textContent = t('cambiarCorreo.listo');
                // El user en sesión queda con el correo nuevo (es su credencial de login).
                const user = ApiClient.getUser();
                if (user) user.email = r.correo || correoNuevo;
            } finally {
                enProgreso = false;
                if (btn.isConnected) {
                    btn.disabled = false;
                    btn.textContent = t('cambiarCorreo.confirmar');
                }
            }
        }

        btn.addEventListener('click', confirmar);
        passEl.addEventListener('keydown', e => {
            if (e.key === 'Enter') confirmar();
        });
        reenviarBtn.addEventListener('click', async () => {
            reenviarBtn.disabled = true;
            errEl.textContent = '';
            const r = await ApiClient.correoSolicitarCodigo(correoNuevo);
            if (!r.ok) errEl.textContent = r.mensaje || t('cambiarCorreo.error');
            setTimeout(() => {
                if (reenviarBtn.isConnected) reenviarBtn.disabled = false;
            }, 5000);
        });
    }

    render();
    return el;
}
